<template>
  <el-dialog
    title="编辑班内职务"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    @close="handleClose"
    destroy-on-close
    width="500px"
  >
    <el-form ref="lForm" :model="lObject" size="small" :rules="rules">
      <el-row>
        <el-col>
          <el-form-item prop="classPost">
            <el-select 
              class=" select-content"
              v-model="lObject.classPost" 
              placeholder="请选择班内职务">
              <el-option
                v-for="(item, i) in postTypeList"
                :key="i"
                :label="item.paramValue"
                :value="item.paramKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click="handleClose" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import vue from "@/main";
import { updatePost } from "@/api/enrollment";
import { getDataMap } from "@/api/sysParam";

export default {
  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      lObject: {
        classPost: "",
        uuid: ""
      },
      rules: {
        classPost: [
          {
            required: true,
            message: "请输入班内职务",
            trigger: ["change", "blur"]
          }
        ]
      },
      postTypeList: []
    };
  },
  methods: {
    handleClose() {
      this.$refs["lForm"].resetFields();
      this.isShow = false;
    },
    submitForm() {
      this.$refs["lForm"].validate(valid => {
        if (valid) {
          let params = {
            uuid: this.lObject.uuid,
            classPost: this.lObject.classPost
          };
          updatePost(params).then(res => {
            if (!res || res.code != 0) return;
            vue.$emit("tableInit");
            this.handleClose();
          });
        }
      });
    }
  },
  created() {
    vue.$on("updatePost", item => {
      this.lObject.uuid = item.uuid;
      if (item.classPostName.indexOf('组长') != -1) {
        this.lObject.classPost = item.classPostName;
      } else {
        this.lObject.classPost = item.classPost;
      }
      this.isShow = true;
    });
    getDataMap("CLASS_POST_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      if (res.data && res.data.length > 0) {
        let list = res.data.filter((item) => item.paramValue.indexOf('组长') === -1)
        this.postTypeList = list;
      } 
    });
  },
  beforeDestroy() {
    vue.$off("updatePost");
  }
};
</script>

<style lang="scss" scoped>
.select-content {
  width: 100% !important;
}
</style>
